import { Can } from 'components/Can';
import MidtermReviewFormCreate from 'features/MidtermReview/pages/Create';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

export default function MidtermReviewFormCreatePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="create" on="midterm_review">
          <MidtermReviewFormCreate />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}
